import { useState, useEffect, useRef } from "react";
import data from "../data/data.json";

const brandMap = [
  {
    brandName: "Flour",
    logo: "/img/logo/unmak.png",
    image: "/img/flours.jpg",
    description:
      "At OTI Foods, our flour products—crafted under the Unmak brand—are made using the finest Canadian grains. We take pride in offering high-quality all-purpose, whole wheat, and specialty flours for home and industrial baking needs.",
    products: data.Flours,
  },
  {
    brandName: "Pasta",
    logo: "/img/logo/ilmak.png",
    image: "/img/pastas.jpg",
    description:
      "Ilmak pasta delivers premium quality and taste. Using 100% durum wheat semolina, we craft delicious traditional shapes and spaghetti varieties to suit every pasta dish.",
    products: data.Pastas,
  },
  {
    brandName: "Oil",
    logo: "/img/logo/bismak.png",
    image: "/img/oils.jpg",
    description:
      "Ilmak pasta delivers premium quality and taste. Using 100% durum wheat semolina, we craft delicious traditional shapes and spaghetti varieties to suit every pasta dish.",
    products: data.Oils,
  },
  {
    brandName: "Confectionery",
    logo: "/img/logo/tubis.png",
    image: "/img/confectionery.jpg",
    description:
      "Ilmak pasta delivers premium quality and taste. Using 100% durum wheat semolina, we craft delicious traditional shapes and spaghetti varieties to suit every pasta dish.",
    products: data.Confectionery,
  },
];

const OtiProductsPage = () => {
  const [selectedBrand, setSelectedBrand] = useState(brandMap[0]);
  const [selectedImageUrl, setSelectedImageUrl] = useState(null);
  const productSectionRef = useRef(null);

  useEffect(() => {
    const brandNameFromSession = sessionStorage.getItem("activeBrand");
    if (brandNameFromSession) {
      const matchedBrand = brandMap.find((b) => b.brandName === brandNameFromSession);
      if (matchedBrand) setSelectedBrand(matchedBrand);
      sessionStorage.removeItem("activeBrand");
    }
  }, []);

  useEffect(() => {
    const hash = window.location.hash;
    if (hash === "#products" && productSectionRef.current) {
      setTimeout(() => {
        productSectionRef.current.scrollIntoView({ behavior: "smooth" });
      }, 50);
    }
  }, []);

  return (
    <section
      style={{
        fontFamily: "'Segoe UI', sans-serif",
        backgroundColor: "#fff",
        color: "#333",
        padding: "40px 20px 80px",
        maxWidth: 1400,
        margin: "0 auto",
        marginTop: "40px",
      }}
    >
      <div
        className="oti-banner"
        style={{
          position: "relative",
          width: "100vw",
          left: "50%",
          marginLeft: "-50vw",
          height: 320,
          backgroundImage: "url('/img/otibg.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: 50,
          boxShadow: "inset 0 0 0 2000px rgba(0,0,0,0.2)",
        }}
      >
        <img
          className="oti-banner-img"
          src="/img/logo/oti.png"
          alt="OTI Foods Logo"
          loading="lazy"
          style={{
            maxHeight: "140px",
            width: "auto",
            filter: "drop-shadow(0 0 4px rgba(0,0,0,0.4))",
          }}
        />
      </div>

      <div
        style={{
          maxWidth: 900,
          marginLeft: "auto",
          marginRight: "auto",
          marginBottom: 40,
          textAlign: "center",
          borderBottom: "1px solid #DDD",
          padding: "0 0 40px 0",
        }}
      >
        <h2
          style={{
            fontSize: "3rem",
            fontWeight: "bold",
            color: "#C38745",
            marginBottom: 20,
          }}
        >
          About Us
        </h2>
        <p
          style={{
            fontSize: "2rem",
            color: "#444",
            lineHeight: 1.7,
          }}
        >
          OTI Foods is dedicated to producing and supplying premium flour and
          pasta products under the Unmak and Ilmak brands. We believe in
          combining tradition, innovation, and the highest-quality Canadian
          grains to deliver exceptional products across the world.
        </p>
        <div ref={productSectionRef}></div>
      </div>

      <div style={{ display: "flex", gap: 40 }} className="oti-wrapper">
        <div style={{
          minWidth: 260,
          maxHeight: "calc(100vh - 120px)",
          overflowY: "auto",
          position: "sticky",
          top: 100,
        }}
          className="oti-sidebar">
          <h3 style={{ fontSize: "2rem", marginBottom: 20, color: "#C38745" }}>
            Product Categories
          </h3>
          {brandMap.map((brand, idx) => (
            <div
              key={idx}
              onClick={() => setSelectedBrand(brand)}
              style={{
                border:
                  brand.brandName === selectedBrand.brandName
                    ? "2px solid #C38745"
                    : "1px solid #ccc",
                padding: 0,
                marginBottom: 10,
                cursor: "pointer",
                textAlign: "center",
                background: "#fdfdfd",
                boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
              }}
            >
              <img
                src={brand.image}
                alt={brand.brandName}
                loading="lazy"
                style={{
                  width: "100%",
                  height: 120,
                  objectFit: "cover",
                  marginBottom: 10,
                }}
              />
              <div style={{ fontWeight: "bold", fontSize: "1.2rem", marginBottom: 10 }}>
                {brand.brandName}
              </div>
            </div>
          ))}
        </div>

        <div style={{ flexGrow: 1 }} className="oti-products">
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 20,
            }}
          >
            <img src={selectedBrand.logo} alt="Brand Logo" loading="lazy" style={{ height: 50 }} />
            <h2
              style={{
                fontSize: "2.4rem",
                fontWeight: "bold",
                color: "#C38745",
                margin: 0,
              }}
            >
              {selectedBrand.brandName}
            </h2>
          </div>

          <p style={{ fontSize: "1.4rem", color: "#555", marginBottom: 30 }}>
            {selectedBrand.description}
          </p>

          <div
            className="oti-product-grid"
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
              gap: 24,
            }}
          >
            {selectedBrand.products.map((item, index) => (
              <div
                key={index}
                style={{
                  background: "#fff",
                  border: "1px solid #e0e0e0",
                  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",
                  overflow: "hidden",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedImageUrl(item.image)}
              >
                <img
                  src={item.image}
                  alt={item.title}
                  loading="lazy"
                  style={{ width: "100%", height: "260px", objectFit: "cover" }}
                />
                <div style={{ padding: 16 }}>
                  <h4
                    style={{
                      fontSize: "1.4rem",
                      fontWeight: "bold",
                      color: "#C38745",
                      marginBottom: 8,
                    }}
                  >
                    {item.title}
                  </h4>
                  <p style={{ fontSize: "1.2rem", color: "#555", marginBottom: 8 }}>
                    {item.description}
                  </p>
                  <p style={{ fontSize: "1.2rem", color: "#555" }}>
                    <strong>Size:</strong> {item.sizes.join(", ")}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {selectedImageUrl && (
        <div
          onClick={() => setSelectedImageUrl(null)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            cursor: "pointer",
          }}
        >
          <img
            src={selectedImageUrl}
            alt="Enlarged"
            loading="lazy"
            style={{
              maxWidth: "90%",
              maxHeight: "90%",
              boxShadow: "0 0 20px rgba(0,0,0,0.5)"
            }}
          />
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .oti-wrapper {
            flex-direction: column;
          }

          .oti-sidebar {
             display: grid !important;
             grid-template-columns: repeat(2, 1fr);
             gap: 8px;
          }
          .oti-sidebar h3 {
             grid-column: span 2;
             text-align: center;
          }

          .oti-products {
            width: 100% !important;
          }

          .oti-product-grid {
            grid-template-columns: 1fr !important;
          }

          .oti-banner {
            height: 200px !important;
          }

          .oti-banner-img {
            max-height: 90px !important;
          }
        }
      `}</style>
    </section>
  );
};

export default OtiProductsPage;
